import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Home Sliders — owner-only control of the two image strips at the bottom of
// the MOBILE home page: "Our Casino" and "New Games".
const homeSliderService = {
  syncStatus: async () => {
    const response = await api.get(API_ENDPOINTS.HOME_SLIDER.SYNC_STATUS)
    return response.data
  },
  // A live read launches Chrome through the proxy (~15-60 s), well past the default timeout.
  syncNow: async () => {
    const response = await api.post(API_ENDPOINTS.HOME_SLIDER.SYNC_RUN, {}, { timeout: 180000 })
    return response.data
  },
  list: async () => {
    const response = await api.get(API_ENDPOINTS.HOME_SLIDER.LIST)
    return response.data
  },
  create: async (data) => {
    const response = await api.post(API_ENDPOINTS.HOME_SLIDER.CREATE, data)
    return response.data
  },
  // title, route, img and enabled are writable; section is identity and fixed.
  update: async (id, data) => {
    const response = await api.put(`${API_ENDPOINTS.HOME_SLIDER.UPDATE}/${id}`, data)
    return response.data
  },
  remove: async (id) => {
    const response = await api.delete(`${API_ENDPOINTS.HOME_SLIDER.DELETE}/${id}`)
    return response.data
  },
  // Full id list of ONE section, first-to-last.
  reorder: async (section, order) => {
    const response = await api.put(API_ENDPOINTS.HOME_SLIDER.REORDER, { section, order })
    return response.data
  },
  // Multipart upload — the server (multer, memory) answers with a base64
  // dataUrl ready to preview and save onto a slider row.
  uploadImage: async (file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(API_ENDPOINTS.HOME_SLIDER.UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },
}

export default homeSliderService
